import { Black } from "src/styles/color";

const IconCart = ({ style, width = 23, height = 21, fill = Black }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      id="icon-cart"
    >
      <path
        d="M1 1H3.44186L4.1932 5M4.1932 5L5.88372 14H19.5581L22 5H4.1932Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="6" cy="18" r="2" fill={fill} />
      <circle cx="19" cy="18" r="2" fill={fill} />
    </svg>
  );
};

export default IconCart;
